import { Component, inject } from '@angular/core';
import { TractorTypeService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  TractorTypeCreateDto,
  TractorTypeDto,
  TractorTypeExcelDownloadDto,
  TractorTypeUpdateDto,
} from '../proxy/general/dtos/tractor-type';
import { TRACTORTYPE_CONFIG, TRACTORTYPE_FIELDS } from './tractor-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-tractor-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, TractorTypeService, ConfirmationService],
  templateUrl: './tractor-type.html',
  styleUrl: './tractor-type.scss',
})
export class TractorType extends BaseCrudComponent<
  TractorTypeDto,
  TractorTypeCreateDto,
  TractorTypeUpdateDto,
  TractorTypeExcelDownloadDto
> {
  service = inject(TractorTypeService);
  config = TRACTORTYPE_CONFIG;
  fields = TRACTORTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: TractorTypeDto): TractorTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'TractorType';
  }
}
